import styled from 'styled-components';
import Link from '../../../Atoms/Link/Link';
export const StyledLink = styled(Link) `
  align-items: center;
  background-color: ${({ theme }) => theme.colorsV2.ui.background.primary};
  box-shadow: 0 0 35px rgba(0, 0, 0, 0.2);
  display: flex;
  font-family: proxima-nova, Corbel, Arial, sans-serif;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm2};
  height: 100%;
  position: relative;
  text-decoration: none;
  width: 100%;
  font-weight: 300;
  color: black;
`;
export const ArrowRightWrapper = styled.div `
  display: flex;
  margin-left: auto;
  margin-right: 15px;
`;
export const ImageWrapper = styled.div `
  min-height: 50px;
  min-width: 50px;
  line-height: 0;
`;
export const ImageLabel = styled.div `
  margin-left: 12px;
  font-size: ${({ theme }) => theme.fontSizes.sizeSm3};
  line-height: 20px;
`;
//# sourceMappingURL=ImageLinkBase.js.map